import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { useConsent } from '../consent/ConsentContext';

export function Footer() {
  const { t } = useTranslation();
  const { openModal } = useConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-zinc-200 dark:border-zinc-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row gap-3 sm:gap-6 items-center justify-between text-xs text-zinc-500">
        <span>{t('footer.copyright', { year })}</span>
        <nav className="flex items-center gap-4 flex-wrap justify-center">
          <Link
            href="/extension"
            className="font-semibold text-[var(--brand)] hover:opacity-80 transition-opacity"
          >
            {t('cookies.footer.download')}
          </Link>
          <Link href="/privacy" className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
            {t('cookies.footer.privacy')}
          </Link>
          <Link href="/terms" className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
            {t('cookies.footer.terms')}
          </Link>
          <Link href="/promise" className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
            {t('cookies.footer.promise')}
          </Link>
          <Link href="/docs" className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors">
            {t('footer.help')}
          </Link>
          <a
            href="/privacy#cookies"
            className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors"
          >
            {t('cookies.footer.cookies')}
          </a>
          <a
            href="mailto:hello@markflow.fyi"
            className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors"
          >
            {t('cookies.footer.contact')}
          </a>
          <button
            type="button"
            onClick={openModal}
            className="hover:text-zinc-900 dark:hover:text-zinc-100 transition-colors"
          >
            {t('cookies.footer.managePreferences')}
          </button>
        </nav>
      </div>
    </footer>
  );
}
